import { twMerge } from 'tailwind-merge';

interface FormSectionTitleProps {
  title: string;
  icon?: React.ReactNode;
  containerClassName?: string;
  titleClassName?: string;
}

export const FormSectionTitle = ({
  title,
  icon,
  containerClassName,
  titleClassName,
}: FormSectionTitleProps) => {
  return (
    <div
      className={twMerge('flex gap-3 self-center mb-2.5', containerClassName)}
    >
      {icon}
      <h3 className={twMerge('font-medium uppercase', titleClassName)}>
        {title}
      </h3>
    </div>
  );
};
